import React from 'react';
const testimonials = [{
  name: 'Valentina R.',
  role: 'Verified Teacher',
  quote: "This literally saved my life. I was teaching 15 classes a week and my brain couldn't handle the planning anymore. Now I just open the curriculum, read for 5 minutes, and I have a beautiful class ready.",
  initials: 'VR'
}, {
  name: 'Camila G.',
  role: 'Verified Teacher',
  quote: 'The verbal cues and philosophy themes are gold. I used to feel insecure when teaching complex sequences; now I have a clear roadmap.',
  initials: 'CG'
}, {
  name: 'Martina L.',
  role: 'Verified Teacher',
  quote: 'For $27 USD, this is a steal. The legal and business tips alone are worth 10x the price. Mandatory for any serious teacher.',
  initials: 'ML'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <div className="text-center mb-12 sm:mb-16" data-id="element-170">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-171">
            What Professional Teachers are Saying
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-172">
            <span className="text-[#E0A52E] text-lg" data-id="element-173">⭐⭐⭐⭐⭐</span>
            <span className="text-text-sec font-medium" data-id="element-174">
              4.9/5 · +1,200 Teachers
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-175">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-main rounded-2xl p-6 border border-border-light shadow-sm flex flex-col" data-id="element-176">
              <div className="flex items-center gap-2 mb-4" data-id="element-177">
                <span className="text-[#E0A52E] text-sm" data-id="element-178">⭐⭐⭐⭐⭐</span>
              </div>
              <p className="text-text-main text-base leading-relaxed mb-6 flex-grow italic" data-id="element-179">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-180">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-181">
                  {t.initials}
                </div>
                <div data-id="element-182">
                  <p className="text-text-main font-bold text-sm" data-id="element-183">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-184">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}